/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Popover from "../../base/popover/components/Popover.web";
import { IconQuestionCircle } from "../../base/icons/svg";
import Icon from "../../base/icons/components/Icon";
import { translate } from "../../base/i18n/functions";
const useStyles = makeStyles()(theme => {
    return {
        container: {
            '& > div': {
                display: 'inline',
            }
        },
        text: {
            lineHeight: '19px',
        },
        iconWrapper: {
            marginLeft: '3px',
            marginBottom: '2px',
            display: 'inline',
            verticalAlign: 'bottom',
        },
        icon: {
            display: 'inline',
            opacity: '30%'
        },
        popoverContent: {
            position: 'relative',
            padding: '5px 8px',
            fontSize: '13px',
            lineHeight: '18px',
            backgroundColor: '#272727',
            maxWidth: '255px',
            borderRadius: '5px',
            marginBottom: '9px',
            cursor: 'pointer',
            textAlign: 'center',
            '&:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                bottom: '-5px',
                left: '49%',
                width: 0,
                height: 0,
                borderRight: '5px solid transparent',
                borderLeft: '5px solid transparent',
                borderTop: '5px solid #272727'
            }
        },
    };
});
const unsupportedText = (props) => {
    const { classes: styles, cx, theme } = useStyles();
    const { t } = props;
    return (React.createElement("div", { className: cx(styles.popoverContent) },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: t('lobby.previewWindow.tooltip') } })));
};
const PrejoinAlwaysShowCheckboxTooltip = (props) => {
    const { classes, theme } = useStyles();
    const [isOpen, changeOpenState] = useState(false);
    return (React.createElement("div", { className: classes.container },
        React.createElement("span", { className: classes.text }, props.t('lobby.previewWindow.check_option')),
        React.createElement(Popover, { content: unsupportedText(props), onPopoverClose: () => changeOpenState(false), position: 'top', trigger: 'click', visible: isOpen },
            React.createElement("div", { className: classes.iconWrapper, onMouseLeave: () => changeOpenState(false), onClick: () => changeOpenState(true), onMouseEnter: () => changeOpenState(true) },
                React.createElement(Icon, { className: classes.icon, color: '#FFF', size: 20, src: IconQuestionCircle })))));
};
function mapStateToProps() {
    return {};
}
const mapDispatchToProps = {};
export default translate(connect(mapStateToProps, mapDispatchToProps)(PrejoinAlwaysShowCheckboxTooltip));
